import { render, staticRenderFns } from "./next.vue?vue&type=template&id=81f62ac8&scoped=true&"
import script from "./next.vue?vue&type=script&lang=js&"
export * from "./next.vue?vue&type=script&lang=js&"
import style0 from "./next.vue?vue&type=style&index=0&id=81f62ac8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f62ac8",
  null
  
)

export default component.exports